/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Description_DescInputs */



/**
* | output |
* | --- |
* | "Export AD with synthetic voice" |
*
* @param {File_Export_Audio_Description_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_description_desc = /** @type {((inputs?: File_Export_Audio_Description_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Description_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter l'AD avec une voix synthetique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportieren Sie AD mit synthetischer Stimme")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione di annunci con voce sintetica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт рекламы с синтезированным голосом")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar AD con voz sintética")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出带有合成语音的广告")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合成音声で広告をエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृत्रिम आवाज के साथ विज्ञापन निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar anúncio com voz sintética")
	return /** @type {LocalizedString} */ ("Export AD with synthetic voice")
});